import { render, staticRenderFns } from "./cmsres-add-or-update.vue?vue&type=template&id=6965bfd7"
import script from "./cmsres-add-or-update.vue?vue&type=script&lang=js"
export * from "./cmsres-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports